import {selectedEnvironment} from "../config/index"
import {PRODUCTION} from "../constants/environment"

export const DYBT_CATEGORY_ID = selectedEnvironment === PRODUCTION ? "23d216e4-1b73-408a-876f-bf8b4f065291" : "51ed273e-9823-48a1-8531-9d40f375cba6"
export const AIRBNB_CATEGORY_ID = selectedEnvironment === PRODUCTION ? "b68fe0ff-ca80-40ad-ad3c-6b44f16226d8" : "ff6a7fe4-60dd-4d3d-9f1f-4ecc998d7da4"